<template>
  <div class="flex flex-wrap mb-4 text-sm textColorBlack">
    <div class="w-1/2 py-3 border-b border-gray-600 px-3">總金額</div>
    <div class="w-1/2 text-right py-3 border-b border-gray-600 px-3">
      <span class="mr-2">NT. </span>
      <span>{{ total }}</span>
    </div>
    <div class="w-1/2 py-3 border-b border-gray-600 px-3">活動折扣</div>
    <div class="w-1/2 text-right py-3 border-b border-gray-600 px-3">
      <span class="mr-2">- NT. </span>
      <span>{{ eventDiscount }}</span>
    </div>
    <div class="w-1/2 py-3 border-b border-gray-600 px-3">訂單折扣</div>
    <div class="w-1/2 text-right py-3 border-b border-gray-600 px-3" >
      <span class="mr-2" v-if="calcPercentage !== 0">({{ calcPercentage }}折)</span>
      <span class="mr-2">- NT. </span>
      <span>{{ calcCartDiscount }}</span>
    </div>
    <div class="w-1/2 py-3 px-3 border-b border-gray-600">運費</div>
    <div class="w-1/2 text-right py-3 px-3 whitespace-no-wrap border-b border-gray-600">
      <span class="mr-2">+ NT. </span>
      <span>{{ shipping }}</span>
    </div>
    <div class="w-1/2 py-3 px-3" v-if="magazine_shipping_fee > 0">訂閱掛號運費</div>
    <div class="w-1/2 text-right py-3 px-3 whitespace-no-wrap" v-if="magazine_shipping_fee > 0">
      <span class="mr-2">+ NT. </span>
      <span>{{ magazine_shipping_fee }}</span>
    </div>
    <div class="w-1/2 py-3 text-white bgLiveBlack px-3">應付金額：</div>
    <div class="w-1/2 text-right py-3 text-white bgLiveBlack px-3">
      <span class="mr-2">NT. </span>
      <span>{{ calcAmount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Money',

  props: {
    total: {
      type: Number
    },
    eventDiscount: {
      type: Number
    },
    shipping: {
      type: Number
    },
    calcAmount: {
      type: Number
    },
    percentage: {
      type: Number
    },
    magazine_shipping_fee: {
      type: Number,
      default: 0
    }
  },
  computed: {
    calcPercentage () {
      let self = this
      if (self.percentage === 100) {
        return 0
      } else if (self.percentage % 10 === 0) {
        return self.percentage / 10
      } else {
        return self.percentage
      }
    },
    calcCartDiscount () {
      let self = this
      if (self.percentage !== 100) {
        let total = self.total
        let eventDiscount = self.eventDiscount
        let percentage = self.percentage
        let discountNum = (total - eventDiscount) * (percentage / 100)
        return total - eventDiscount - Math.round(discountNum)
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
